import { PublicClientApplication, EventType, EventMessage, AuthenticationResult } from "@azure/msal-browser";
import { msalConfig } from "./AuthorizationConfig";
import { pickPreferredAccount, resetLoginRedirectGuard } from "./msalGuards";

// Create the MSAL application object
const msalInstance = new PublicClientApplication(msalConfig);

// This should be called at least once before any other MSAL method
// Export a promise to track when initialization is complete
export const msalInit = msalInstance.initialize()
  .then(() => {
    // Handle login success events
    msalInstance.addEventCallback((event: EventMessage) => {
      if (event.eventType === EventType.LOGIN_SUCCESS) {
        console.log("Login success");
        const result = event.payload as AuthenticationResult;
        if (result && result.account) {
          msalInstance.setActiveAccount(result.account);
        }
        resetLoginRedirectGuard();
      } else if (event.eventType === EventType.LOGOUT_SUCCESS) {
        console.log("Logout success");
        resetLoginRedirectGuard();
      } else if (event.eventType === EventType.LOGIN_FAILURE) {
        console.error("Login failure:", event.error);
      }
    });

    // Handle the redirect flow once immediately at startup
    return msalInstance.handleRedirectPromise()
      .then((response) => {
        if (response?.account) {
          msalInstance.setActiveAccount(response.account);
        } else {
          const accounts = msalInstance.getAllAccounts();
          if (accounts.length > 0) {
            msalInstance.setActiveAccount(pickPreferredAccount(accounts));
          }
        }
        return msalInstance;
      })
      .catch((error) => {
        console.error("Error during redirect handling:", error);
        return msalInstance;
      });
  })
  .catch(error => {
    console.error("Error initializing MSAL:", error);
    return msalInstance;
  });

// Export default msalInstance for components to use
export default msalInstance;

// LOGIN 
// export const login = async () => {
//   await msalInstance.loginRedirect({
//     scopes: loginRequest.scopes,
//     prompt: "select_account",
//   });
// }

// LOGOUT
export const logout = async () => {
  localStorage.removeItem('userRoles');
  try {
    for (let i = sessionStorage.length - 1; i >= 0; i--) {
      const k = sessionStorage.key(i);
      if (k?.startsWith("dentifier.msal.popupFailed.")) {
        sessionStorage.removeItem(k);
      }
    }
  } catch {
    /* ignore */
  }

  resetLoginRedirectGuard();

  const active = msalInstance.getActiveAccount();
  const allAccounts = msalInstance.getAllAccounts();

  for (const account of allAccounts) {
    try {
      await msalInstance.clearCache({ account });
    } catch (e) {
      console.warn("MSAL clearCache:", e);
    }
  }
  msalInstance.setActiveAccount(null);

  await msalInstance.logoutRedirect({
    account: active ?? undefined,
    postLogoutRedirectUri: msalConfig.auth.postLogoutRedirectUri,
  });
}